module.exports = __webpack_public_path__ + "img/kpis-banner.9edd4205.png";